/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect, useSelector } from 'react-redux';

import { withRouter } from 'react-router';
import { bool } from 'prop-types';
import { compose } from 'recompose';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import NativeSigninUIComponent from './NativeSigninUIComponent';
import { getIsAuthenticatedStatus } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { trackData, trackPage } from '../../../helpers/tracking/common/commonTrackingHelpers';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const NativeSigninPageContainer = ({ isUserAuthenticated }) => {
    if (typeof window === 'undefined') return <></>;

    const isNativeLoginEnabled = useSelector(getFeatureFlag('is-native-login-enabled'));

    trackData({
        action: 'track_native_signin_page_data',
    });

    if (isUserAuthenticated || !isNativeLoginEnabled) {
        window?.location.replace('/');
        return <></>;
    }
    return <NativeSigninUIComponent />;
};

NativeSigninPageContainer.propTypes = {
    isUserAuthenticated: bool,
};

NativeSigninPageContainer.defaultProps = {
    isUserAuthenticated: false,
};

const mapStateToProps = (state) => ({
    isUserAuthenticated: getIsAuthenticatedStatus(state),
});

const enhance = compose(
    withRouter,
    trackPage({
        type: 'native-signin-page',
        name: 'Native signin Page',
        pageType: 'native-signin-page',
        pageName: 'Native Signin Page',
    }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    connect(mapStateToProps),
);

export default enhance(NativeSigninPageContainer);
